/* Cart quantity steppers. Submits the real Shopify cart form, so with JS
   disabled the number input and the update button still work. */
(function () {
  'use strict';
  document.querySelectorAll('.tih-cart .tih-qty').forEach(function (widget) {
    var input = widget.querySelector('.tih-qty__input');
    if (!input) return;

    widget.addEventListener('click', function (e) {
      var btn = e.target.closest('.tih-qty__btn');
      if (!btn) return;

      var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
      var next = (parseInt(input.value, 10) || 0) + step;
      input.value = next < 0 ? 0 : next;

      var form = input.closest('form');
      if (form) form.submit();   // 0 removes the line, which is Shopify's own behaviour
    });
  });
})();
